// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"ddf5c49c","608":"a46be8cb","644":"63b2677d"}[chunkId] + ".chunk.js";
};